export const games: TableModule = {
    name: "games",
    route: "spa.sportsManagement.gameDays.games",
    defaultOrder: {
        column: "date",
        direction: "asc"
    },
    routeParams: [{
        param: "gameDay",
        prop: "game_day_id"
    }],
    columns: [
        {
            name: "number",
            width: 'w-[150px]',
            sortable: true,
            breakpoint: "xl",
        }, {
            name: "date",
            sortable: true,
            pageLink: true,
            mobile: true,
            width: 'w-[130px] xl:w-[200px]'
        }, {
            name: "contest",
            sortable: true,
            sortBy: "contests.name",
            width: 'w-[200px]',
            breakpoint: "xl",
        }, {
            name: "opponents",
            mobile: true,
        }, {
            name: "referee",
            breakpoint: "lg",
        }, {
            name: "score",
            width: 'w-[120px]',
        }
    ],
    filters: [
        {
            name: "contest",
            column: "contest_id",
            type: "searchSelect",
            reduced: "in",
            spaRoute: "spa.sportsManagement.contests.index",
            additionalDisplayKey: "game_class_name",
            searchThreshold: 1,
            searchSelectConfig: {
                fetchOnSearch: false,
            },
            ability: ['viewAny', 'contests']
        }
    ],
    quickFilters: [
        {
            name: "qfWithoutScore",
            column: "team_a_score",
            operator: "isNull",
            value: "null",
        }, {
            name: "qfWithoutConfirmation",
            column: "customFilterWithoutConfirmation",
            operator: "=",
            value: false,
        }
    ],
    tools: [
        {
            isCreateAction: true,
            ability: ["create", "games"]
        }
    ]
}